import { createFileRoute } from '@tanstack/react-router';

interface OAuthCallbackSearch {
  status?: string;
  oauthProviderId?: string;
  platformConnectorId?: string;
  requiresOrganisationReview?: string;
  reason?: string;
}

// Top-level (NOT under /integrations) so the OAuth tab doesn't mount the
// integrations layout — otherwise its `useIntegrationOAuthListener` would
// receive the bridge's own broadcast and navigate instead of closing.
export const Route = createFileRoute('/oauth/callback')({
  validateSearch: (search: Record<string, unknown>): OAuthCallbackSearch => ({
    status: typeof search.status === 'string' ? search.status : undefined,
    oauthProviderId:
      typeof search.oauthProviderId === 'string' ? search.oauthProviderId : undefined,
    platformConnectorId:
      typeof search.platformConnectorId === 'string' ? search.platformConnectorId : undefined,
    requiresOrganisationReview:
      typeof search.requiresOrganisationReview === 'string'
        ? search.requiresOrganisationReview
        : undefined,
    reason: typeof search.reason === 'string' ? search.reason : undefined,
  }),
});
